import React, { type ReactNode } from "react";
import { InputLabel } from "src/components/InputLabel/InputLabel.tsx";

export const Label = ({
  label,
  required = false,
  helperText,
  additionalLabelElems,
}: {
  label: ReactNode;
  required?: boolean;
  helperText: ReactNode;
  additionalLabelElems?: ReactNode[];
}) => {
  return (
    label && (
      <InputLabel
        label={label}
        required={required}
        helperText={helperText}
        additionalElems={additionalLabelElems}
      />
    )
  );
};
